import { toast } from 'react-toastify';

export const ExportData = async (apiUrl, requestBody, requestHeaders) => {
    try {
        const response = await fetch(apiUrl, {
            method: 'POST',
            body: JSON.stringify(requestBody),
            headers: requestHeaders,
        });
        if (response.ok) {
            const responseData = await response.json();
            if (responseData.status === 'SUCCESS' || responseData.Status === 'SUCCESS') {
                if (responseData) {
                    const records = responseData;
                    return records;
                } else {
                    // console.error('Invalid response format. Expected an array of records.');
                }
            } else {
                toast.error(responseData.message, {
                    position: 'top-center',
                });
            }
        }
    } catch (err) {
        toast.error(err.message, {
            position: 'top-center',
        });
    }
};
